 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import CONTENTCONTENT0004 from '@/components/content/content0004'
 import CONTENTCONTENT0008 from '@/components/content/content0008'
 import CONTENTCONTENT0010 from '@/components/content/content0010'
 import CONTENTCONTENT0012 from '@/components/content/content0012'
 import CONTENTCONTENT0016 from '@/components/content/content0016'
 import CONTENTCONTENT0018 from '@/components/content/content0018'
 import CONTENTCONTENT0022 from '@/components/content/content0022'
 import CONTENTCONTENT0024 from '@/components/content/content0024'
 import CONTENTCONTENT0026 from '@/components/content/content0026'
 import CONTENTCONTENT0028 from '@/components/content/content0028'
 import CONTENTCONTENT0031 from '@/components/content/content0031'
 import CONTENTCONTENT0033 from '@/components/content/content0033'
 import CONTENTCONTENT0036 from '@/components/content/content0036'
 import CONTENTCONTENT0040 from '@/components/content/content0040'
 import CONTENTCONTENT0042 from '@/components/content/content0042'
 import CONTENTCONTENT0044 from '@/components/content/content0044'
 import CONTENTCONTENT0048 from '@/components/content/content0048'
 import CONTENTCONTENT0051 from '@/components/content/content0051'
 import CONTENTCONTENT0053 from '@/components/content/content0053'
 import CONTENTCONTENT0055 from '@/components/content/content0055'
 import CONTENTCONTENT0061 from '@/components/content/content0061'
 import CONTENTCONTENT0064 from '@/components/content/content0064'
 import CONTENTCONTENT0066 from '@/components/content/content0066'
 import CONTENTCONTENT0069 from '@/components/content/content0069'
 import CONTENTCONTENT0072 from '@/components/content/content0072'
 import CONTENTCONTENT0076 from '@/components/content/content0076'
 import CONTENTCONTENT0078 from '@/components/content/content0078'
 import CONTENTCONTENT0082 from '@/components/content/content0082'
 import CONTENTCONTENT0084 from '@/components/content/content0084'
 import CONTENTCONTENT0088 from '@/components/content/content0088'
 import CONTENTCONTENT0091 from '@/components/content/content0091'
 import CONTENTCONTENT0094 from '@/components/content/content0094'
 import CONTENTCONTENT0098 from '@/components/content/content0098'
 import CONTENTCONTENT0102 from '@/components/content/content0102'
 import CONTENTCONTENT0104 from '@/components/content/content0104'
 import CONTENTCONTENT0106 from '@/components/content/content0106'
 import CONTENTCONTENT0109 from '@/components/content/content0109'
 import CONTENTCONTENT0115 from '@/components/content/content0115'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content/content0004",
 			"name" : "content/content0004",
 			"component" : CONTENTCONTENT0004
 		},
 		{
 			"path" : "/content/content0008",
 			"name" : "content/content0008",
 			"component" : CONTENTCONTENT0008
 		},
 		{
 			"path" : "/content/content0010",
 			"name" : "content/content0010",
 			"component" : CONTENTCONTENT0010
 		},
 		{
 			"path" : "/content/content0012",
 			"name" : "content/content0012",
 			"component" : CONTENTCONTENT0012
 		},
 		{
 			"path" : "/content/content0016",
 			"name" : "content/content0016",
 			"component" : CONTENTCONTENT0016
 		},
 		{
 			"path" : "/content/content0018",
 			"name" : "content/content0018",
 			"component" : CONTENTCONTENT0018
 		},
 		{
 			"path" : "/content/content0022",
 			"name" : "content/content0022",
 			"component" : CONTENTCONTENT0022
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js